'use client';

import { FC } from 'react';
import { gridItems } from '@/data';

import { BentoGrid, BentoGridItem } from '../ui/bento-grid';

export const Grid: FC = () => {
  return (
    <section>
      <BentoGrid className="w-full">
        {gridItems.map((item) => (
          <BentoGridItem
            key={item.id}
            {...item}
          />
        ))}
      </BentoGrid>
    </section>
  );
};
